import { useMemo, useState } from 'react';

import { LoadingState } from '@/shared/ui/states/LoadingState/LoadingState';
import { Tree } from '@/shared/ui/Tree';

import { useAssetTreeRender } from '@/features/discovery';
import { useIcebergTreeData } from '@/features/user-management/hooks/useIcebergTreeData';

import styles from './TablePermissionTree.module.css';

type TablePermissionTreeProps = {
  checkedKeys: React.Key[];
  onCheck: (checkedKeys: React.Key[]) => void;
};

export const TablePermissionTree: React.FC<TablePermissionTreeProps> = ({ checkedKeys, onCheck }) => {
  const { treeData, isLoading } = useIcebergTreeData();
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>([]);

  const { enrichTreeData } = useAssetTreeRender();

  const enrichedTreeData = useMemo(() => enrichTreeData(treeData, styles), [treeData, enrichTreeData]);

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <LoadingState message="데이터베이스 목록을 불러오는 중..." />
      </div>
    );
  }

  if (treeData.length === 0) {
    return <div className={styles.emptyState}>데이터베이스가 없습니다.</div>;
  }

  return (
    <Tree
      checkable
      disabled
      treeData={enrichedTreeData}
      checkedKeys={checkedKeys}
      expandedKeys={expandedKeys}
      onCheck={(checked) => {
        onCheck(checked as React.Key[]);
      }}
      onExpand={(keys) => {
        setExpandedKeys(keys);
      }}
    />
  );
};
